export const generalHint =  "Please attach any materials you have that will help us complete this project (e.g.Excel tables, images, Word documents, PowerPoints, native design files, notes,videos, etc.)."
